import { taxonomyAPI } from '@/providers/apis/taxonomy/taxonomy';
import { tenantSettingsAPI } from '@/providers/apis/tenant-settings/tenant-settings';
import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import axios from 'axios';

@Component({
    name: 'tx-category-prefer',
    components: {

    },
})

export default class TxCategoryPrefer extends Vue {


    // ------------------------------------------------------------------------------------
    // Properties

    @Prop()
    private selectedConfig: any;

    @Prop()
    private tenantSettings: any;

    private classificaitonList: any = [];



    private defaultCategory: any = null;

    private get selectedCategory() {
        return this.classificaitonList.filter((item: any) => item && item.isActive) || [];
    }

    private get activePreference() {
        return this.tenantSettings.find((item: any) => item.key === 'tx_sub_classifier_prefs') || {};
    }

    // ----------------------------------------------------------------------------------
    // Hooks
    private created() {
        this.loadClassification();
    }

    // ---------------------------------------------------------------------------------
    // Actions

    private onSelectCategory(category: any) {
        this.$set(category, 'isActive', category.isActive ? false : true);
    }

    private onSelectDefault(item: any) {
        this.defaultCategory = item.id;
    }

    private onSubmitCategory(category: any) {
        this.parseCategory();
        this.$emit('onGoNext', 'tx-subject', category);
    }

    private loadClassification() {
        this.classificaitonList = [];
        axios.all([
            tenantSettingsAPI.fetchClassification(),
            taxonomyAPI.fetchTaxonomyClassifications(),
        ]).then(axios.spread((classificiation: any, taxonomyClassification) => {
                classificiation.map((item: any) => {
                    item.count = 0;
                    const txCode = taxonomyClassification.find((txItem: any) => item.id === txItem.id);
                    if (txCode) {
                        if (this.selectedConfig.tenantConfig && this.selectedConfig.tenantConfig.value) {
                            this.defaultCategory = this.selectedConfig.tenantConfig.value.default_classifier;
                        }
                        this.$set(item, 'isActive', true);
                        this.$set(item, 'isCategory', true);
                    }
                });
                this.classificaitonList = classificiation;
        }));
    }

    private parseCategory() {
        const config: any = {};
        config.ids = this.selectedCategory.map((item: any) => item.id);
        config.default_classifier = this.defaultCategory;
        config.is_global_visible = false;
        if (!this.activePreference) {
            this.$set(this.activePreference, 'value', config);
            this.$set(this.activePreference, 'key', 'tx_sub_classifier_prefs');
        }
        this.$set(this.activePreference, 'value', config);
        this.$emit('onChangeConfig', 'tx_sub_classifier_prefs', config);
    }

}
